"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.number.constructor");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerTreeDropArea = exports.BmTreeDropArea = void 0;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _bmTreeStore = require("./bm-tree-store");

var _bmTreeItem = require("./bm-tree-item");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: block;\n\t\theight: 2px;\n\t\tbackground: transparent;\n\t\toutline: none;\n\t}\n\t:host(.drag-over) {\n\t\tbackground: #000;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmTreeDropArea = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmTreeDropArea, _BlueElement);

  var _super = (0, _createSuper2.default)(BmTreeDropArea);

  (0, _createClass2.default)(BmTreeDropArea, null, [{
    key: "is",
    get: function get() {
      return 'bm-tree-drop-area';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        parentId: {
          type: String,
          attribute: true,
          reflect: true
        },
        index: {
          type: Number,
          attribute: true,
          reflect: true
        },
        store: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmTreeDropArea() {
    var _context, _context2, _context3;

    var _this;

    (0, _classCallCheck2.default)(this, BmTreeDropArea);
    _this = _super.call(this);
    _this.parentId = void 0;
    _this.index = void 0;
    _this.store = void 0;
    _this.parentId = '';
    _this.index = 0;
    _this.store = new _bmTreeStore.TreeStore();
    _this.handleDrop = (0, _bind.default)(_context = _this.handleDrop).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.handleDragEnter = (0, _bind.default)(_context2 = _this.handleDragEnter).call(_context2, (0, _assertThisInitialized2.default)(_this));
    _this.handleDragLeave = (0, _bind.default)(_context3 = _this.handleDragLeave).call(_context3, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmTreeDropArea, [{
    key: "handleDragEnter",
    value: function handleDragEnter(e) {
      var _e$dataTransfer, _context4;

      e.preventDefault();

      if ((_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : (0, _includes.default)(_context4 = _e$dataTransfer.types).call(_context4, 'text/plain')) {
        e.dataTransfer.dropEffect = 'move';
        this.classList.add('drag-over');
      }
    }
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave(e) {
      e.preventDefault();
      this.classList.remove('drag-over');
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e) {
      var _e$dataTransfer2, _context5;

      e.preventDefault();
      this.classList.remove('drag-over');

      if ((_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : (0, _includes.default)(_context5 = _e$dataTransfer2.types).call(_context5, 'text/plain')) {
        var transferData = JSON.parse(e.dataTransfer.getData('text/plain'));
        var newParent;
        var oldIndex;
        var newIndex;
        var oldParent = this.store.get(transferData.parentId).details;

        if (transferData.parentId === this.parentId) {
          oldIndex = transferData.index;
          newIndex = this.index;
        } else {
          newParent = this.store.get(this.parentId).details;
        }

        var emitData = {
          treeItem: this.store.get(transferData.id).details,
          oldParent: oldParent,
          newParent: newParent,
          oldIndex: oldIndex,
          newIndex: newIndex
        };
        this.dispatchEvent(new CustomEvent('dropped-moved-item', {
          detail: emitData
        }));
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeDropArea.prototype), "connectedCallback", this).call(this);
      this.addEventListener('drop', this.handleDrop);
      this.addEventListener('dragenter', this.handleDragEnter);
      this.addEventListener('dragover', _bmTreeItem.cancelEvent);
      this.addEventListener('dragleave', this.handleDragLeave);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeDropArea.prototype), "disconnectedCallback", this).call(this);
      this.removeEventListener('drop', this.handleDrop);
      this.removeEventListener('dragenter', this.handleDragEnter);
      this.removeEventListener('dragover', _bmTreeItem.cancelEvent);
      this.removeEventListener('dragleave', this.handleDragLeave);
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }]);
  return BmTreeDropArea;
}(_element.BlueElement);

exports.BmTreeDropArea = BmTreeDropArea;

var registerTreeDropArea = function registerTreeDropArea() {
  return (0, _element.register)(BmTreeDropArea);
};

exports.registerTreeDropArea = registerTreeDropArea;
